import { render, staticRenderFns } from "./ModalReturnPoints.vue?vue&type=template&id=36fecb9c&scoped=true"
import script from "./ModalReturnPoints.vue?vue&type=script&lang=js"
export * from "./ModalReturnPoints.vue?vue&type=script&lang=js"
import style0 from "./ModalReturnPoints.vue?vue&type=style&index=0&id=36fecb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fecb9c",
  null
  
)

export default component.exports